


































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { StatusItemModel } from '@/model/charactersheets';

@Component
export default class Item extends Vue {
  @Prop() public label!: string;
  @Prop() public values!: StatusItemModel;
  @Prop() public gamesystem!: number | null;

  @Emit() public update(payload: StatusItemModel) {}

  private get receiver() {
    return this.values;
  }

  private get total() {
    return this.gamesystem === 1
      ? this.values.default * 5 + this.values.correction
      : this.values.default + this.values.correction;
  }

  public updateValue(payload: StatusItemModel) {
    this.update(payload);
  }
}
